import {CustomCheckbox} from '../components/CustomCheckbox'

export default class Registration {
    init() {

        const config = {
            //custom checkbox
            jsRadio: $('.js-radio'),
            jsRadioTrigger: $('.js-radio-trigger')

        };
        const customCheckbox = new CustomCheckbox(config);
        customCheckbox.init();

        }

    }





// WEBPACK FOOTER //
// ./static/js/pages/Pricelist.js